export const appointmentKeys = {
    all: ["appointments"] as const,
    availableTimeSlots: (date: string, timeZone: string) => [...appointmentKeys.all, "time-slots", date, timeZone] as const,
    calenderSettings: () => [...appointmentKeys.all, "calender-settings"] as const,
    appointmentById: (id?: string) => [...appointmentKeys.all, "appointment", id] as const,
    reschedule: (id: string) => [...appointmentRescheduleKeys.all, "reschedule", id] as const,
  } as const;

  export const appointmentRescheduleKeys = {
    all: ["appointments", "reschedule"] as const,
    appointment: (id: string) => [...appointmentKeys.all, id] as const,
    reschedule: (id: string) => [...appointmentRescheduleKeys.all, "reschedule", id] as const,
  };

  export const consultationKeys = {
    all: ["consultations"] as const,
    consultationById: (id?: string) => [...consultationKeys.all, "consultation", id] as const,
  }
 